/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Číselník typů úložných jednotek zařízení.
 * @enum {string}
 */
const DriveEnum = {
  /** Úložná jednotka, která může být ze zařízení odebrána. */
  EXTERNAL: 'EXTERNAL',
  /** Úložná jednotka, která je vnitřní součástí zařízení. */
  INTERNAL: 'INTERNAL'
};

export default DriveEnum;
